
import { Component, Vue } from "vue-property-decorator";
import { Route, NavigationGuardNext } from "vue-router";
import { State, Mutation } from "vuex-class";
import { IUser } from "@/store/modules/auth/types";
import { resetStore } from "@/store";

const namespace = "authModule";

Component.registerHooks(["beforeRouteLeave", "beforeRouteEnter"]);

@Component({
  name: "logout",
})
export default class Logout extends Vue {
  @State("account", { namespace })
  public account!: IUser;

  @Mutation("setLogout", { namespace: "authModule" })
  public setLogout!: any;

  get permissions() {
    const acc = this.account;
    return acc.permissions;
  }

  public beforeRouteEnter(
    to: Route,
    from: Route,
    next: NavigationGuardNext<Logout>
  ) {
    next(async vm => {
      vm.setLogout();
      await vm.$router.push("/login");
      resetStore();
    });
  }

  public render() {
    return (
      this.$scopedSlots &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({})
    );
  }
}
